import PropTypes from 'prop-types';
import React from 'react';
import { Multiselect } from 'react-widgets';
import { Field } from 'redux-form';
import { map, keyBy } from 'lodash';
import SimpleCheckbox from '../../../../common/simpleCheckbox';

const mapValueToCollection = (value, sources) => {
  const sourcesMap = keyBy(sources, 'id');
  const objectByKeyOrKey = (keyOrObject) => {
    if (typeof keyOrObject === 'string') {
      return sourcesMap[keyOrObject] || keyOrObject;
    }

    return keyOrObject;
  };

  return map(value || [], objectByKeyOrKey);
};

const renderMultiselect = ({ input, data, meta: { touched, error } }) => (
  <div className="u-position-relative">
    <Multiselect
      {...input}
      onBlur={() => input.onBlur()}
      value={mapValueToCollection(input.value, data)}
      data={data}
      valueField="id"
      textField={service => service.name}
      filter="contains"
    />
    {touched && error && <div className="c-input-error-message">{error}</div>}
  </div>
);

const PromoForServicesAndProducts = ({ isForServicesOrProducts, services, products }) => (
  <div className="layout">
    <div className="layout__item u-1/1 u-nowrap">
      <SimpleCheckbox
        label="Limit Promo to Certain Services or Products"
        id="isForServicesOrProducts"
        name="isForServicesOrProducts"
      />
    </div>
    <div className="layout__item u-1/2" display-if={isForServicesOrProducts}>
      <span className="c-label-new">Services</span>
      <Field
        name="services"
        component={renderMultiselect}
        data={services}
      />
    </div>
    <div className="layout__item u-1/2" display-if={isForServicesOrProducts}>
      <span className="c-label-new">Products</span>
      <Field
        name="products"
        component={renderMultiselect}
        data={products}
      />
    </div>
  </div>
);

const NamedEntity = PropTypes.shape({ id: PropTypes.string, name: PropTypes.string });

PromoForServicesAndProducts.propTypes = {
  isForServicesOrProducts: PropTypes.bool.isRequired,
  services: PropTypes.arrayOf(NamedEntity).isRequired,
  products: PropTypes.arrayOf(NamedEntity).isRequired,
};

export default PromoForServicesAndProducts;
